import { resolveUrl } from './catalog-list';
import type { WorldBookGate } from './types';

export type { WorldBookGate };
function el(tag: string, cls = '', text = ''): HTMLElement {
    const node = document.createElement(tag); node.className = cls; node.textContent = text; return node;
}
function link(text: string, url: string, cls = ''): HTMLAnchorElement {
    const node = document.createElement('a'); node.className = cls; node.textContent = text;
    node.href = resolveUrl(url); return node;
}
export function worldBookGateCard(gate: WorldBookGate, name: string): HTMLElement {
    const card = el('aside', 'ft-wb-gate');
    card.setAttribute('data-wb-gate', '');
    card.append(el('div', 'ft-wb-kicker', 'The full World Book'),
        el('p', '', `You're reading a sample of ${name}. The full book is part of ${gate.source_name}.`));
    const actions = el('div', 'ft-wb-gate-actions');
    actions.append(link(gate.via_plus ? 'Get Plus' : `Get ${gate.source_name}`, gate.via_plus ? gate.subscribe_url : gate.source_url, 'btn btn-primary'),
        link(`About ${gate.source_name}`, gate.source_url, 'btn btn-outline-secondary'));
    if (gate.login_url) actions.append(link('Sign in', gate.login_url));
    card.append(actions);
    return card;
}
